class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    //Enavi custom Js related to the header
    this.grandchildLinks = document.querySelectorAll('.link-grandchild');
    this.grandchildLinks.forEach(link => {
      link.addEventListener('mouseover', event => {
        event.preventDefault();
        const childMenuHandle = link.dataset.childMenu;
        const childMenu = document.querySelector(`[data-parent-menu="${childMenuHandle}"]`);
        const otherChildMenus = document.querySelectorAll(`[data-parent-menu]:not([data-parent-menu="${childMenuHandle}"])`);
        otherChildMenus.forEach(menu => {
          menu.classList.remove('active');
        });
        childMenu.classList.add('active');
        childMenu.parentElement.classList.add('active');

        this.grandchildLinks.forEach(link => {
          link.classList.remove('active');
        });
        link.classList.add('active');

        const parentWrapper = link.closest('details');
        if (parentWrapper && parentWrapper.querySelector('.feature_img_container')) {
          parentWrapper.classList.remove('one-col');
          parentWrapper.classList.add('two-cols');
        }
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    //Enavi custom Js related to the grandchild menus
    const grandchildMenus = this.mainDetailsToggle.querySelectorAll('.grandchild_menu');
    grandchildMenus.forEach(menu => {
        menu.classList.remove('active');
    });
    
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.grandchildLinks.forEach(link => {
        link.classList.remove('active');
      });
      var menuFirstItem = this.mainDetailsToggle.querySelector('.second-level li:first-child');
      if (menuFirstItem && menuFirstItem.classList.contains('link-grandchild')) {
        if (this.mainDetailsToggle.querySelector('.feature_img_container')) {
          this.mainDetailsToggle.classList.remove('one-col');
          this.mainDetailsToggle.classList.add('two-cols');
        }
       
        const firstChildMenu = this.mainDetailsToggle.querySelector('.grandchild_menu');
        if (firstChildMenu) {
          firstChildMenu.parentElement.classList.add('active');
          firstChildMenu.classList.add('active');
  
          const firstGrandchildLink = this.mainDetailsToggle.querySelector('.link-grandchild');
          if (firstGrandchildLink) {

            firstGrandchildLink.classList.add('active');
          }
        }
      }else{
        this.mainDetailsToggle.classList.add('one-col');
        this.mainDetailsToggle.classList.remove('two-cols');
      }
    } else {
      const firstChildMenu = this.mainDetailsToggle.querySelector('.grandchild_menu');
      if (firstChildMenu) {
        firstChildMenu.parentElement.classList.remove('active');
      }
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
